"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../..");

var _mobxReact = require("mobx-react");

var _useUtils = require("../../_helpers/use-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./Dropdown.css");

var _styles = {
  "dropdown-container": "Dropdown__dropdown-container___3z5oC",
  "text-field": "Dropdown__text-field___2KVvn",
  "ref": "Dropdown__ref___vy7Ac",
  "fade_in": "Dropdown__fade_in___3pOK9",
  "dropdown-list": "Dropdown__dropdown-list___3BzQv",
  "top": "Dropdown__top___2PGmQ",
  "has-label": "Dropdown__has-label___gFEEc",
  "disabled": "Dropdown__disabled___34jpv",
  "item-active": "Dropdown__item-active___D7HRU",
  "default-selected": "Dropdown__default-selected___1Uulo"
};

const styles = _bind.default.bind(_styles);

const Dropdown = (0, _mobxReact.observer)(({
  className,
  name = 'dropdown',
  label,
  disabled,
  error,
  placeholder,
  required,
  small,
  defaultSelected,
  disableBrowserAutofill = true,
  options,
  helperText,
  value,
  onInputChange,
  dataTestId,
  secondaryLabel,
  secondaryLabelTheme,
  displayDirection = 'bottom',
  selectOnly
}) => {
  const [inputValue, setInputValue] = (0, _react.useState)(undefined);
  const [showSuggestions, setShowSuggestions] = (0, _react.useState)(false);
  const [suggestionsList, setSuggestionsList] = (0, _react.useState)([...options]);
  const [activeSelection, setActiveSelection] = (0, _react.useState)(0);
  const dropdownRef = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    if (inputValue === '') {
      onInputChange('');
      return;
    }
  }, [inputValue]);
  (0, _react.useEffect)(() => {
    setSuggestionsList([...options]);
  }, [options]);
  (0, _useUtils.useDocumentEvent)('mousedown', event => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowSuggestions(false);
    } else {
      setShowSuggestions(true);
    }
  });

  const onDropdownChange = e => {
    const user_input = e.currentTarget.value;

    if (user_input.length === 0) {
      setActiveSelection(0);
      setShowSuggestions(false);
    } else if (user_input.length > 0) {
      setShowSuggestions(true);
    }

    const matchesUserInput = inputValue => {
      return inputValue.toLowerCase().startsWith(user_input.toLowerCase());
    };

    const filterSuggestions = options.filter(suggestion => {
      if (typeof suggestion === 'string') {
        if (!matchesUserInput(suggestion)) return false;
        return suggestion.toLowerCase().indexOf(user_input.toLowerCase()) > -1;
      } else {
        if (!matchesUserInput(suggestion.name)) return false;
        return (suggestion === null || suggestion === void 0 ? void 0 : suggestion.name.toLowerCase().indexOf(user_input.toLowerCase())) > -1;
      }
    });
    setActiveSelection(0);
    setSuggestionsList(filterSuggestions);
    setInputValue(user_input);
  };

  const selectionClick = i => {
    const selected = suggestionsList[i];
    setSuggestionsList(options);

    if (typeof selected === 'string') {
      setInputValue(selected);
    } else {
      setInputValue(selected === null || selected === void 0 ? void 0 : selected.name);
    }

    setShowSuggestions(false);
    onInputChange(selected);
  };

  const composed_classname = (0, _bind.default)(styles('dropdown-container', {
    disabled,
    'has-label': label
  }), className);
  const optionRefs = (0, _react.useRef)({});

  const scrollIntoViewOnKeyDown = el => {
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      });
    }
  };

  const onKeyDown = e => {
    if (e.keyCode === 8) {
      setSuggestionsList(options);
      setShowSuggestions(true);
    } else if (e.keyCode === 13) {
      const selected = suggestionsList[activeSelection];
      setSuggestionsList(options);

      if (typeof selected === 'string') {
        setInputValue(selected);
      } else {
        setInputValue(selected === null || selected === void 0 ? void 0 : selected.name);
      }

      setShowSuggestions(false);
      onInputChange(selected);
    } else if (e.keyCode === 38) {
      if (activeSelection !== 0) {
        setActiveSelection(activeSelection - 1);
        scrollIntoViewOnKeyDown(optionRefs.current[activeSelection - 1]);
      }
    } else if (e.keyCode === 40) {
      setShowSuggestions(true);

      if (activeSelection !== suggestionsList.length - 1) {
        setActiveSelection(activeSelection + 1);
        scrollIntoViewOnKeyDown(optionRefs.current[activeSelection + 1]);
      }
    }
  };

  (0, _useUtils.useEffectOnce)(() => {
    var _a;

    if (defaultSelected) {
      onInputChange(suggestionsList[0]);

      if (typeof suggestionsList[0] === 'string') {
        setInputValue(suggestionsList[0]);
      } else {
        setInputValue((_a = suggestionsList[0]) === null || _a === void 0 ? void 0 : _a.name);
      }
    }
  });
  return _react.default.createElement("div", {
    className: composed_classname,
    "data-testid": dataTestId
  }, _react.default.createElement("div", {
    className: styles('ref'),
    ref: dropdownRef
  }, _react.default.createElement(_.TextField, {
    dataTestId: dataTestId && `${dataTestId}-textfield`,
    className: styles('text-field', {
      'default-selected': defaultSelected || selectOnly
    }),
    name: disableBrowserAutofill ? new Date().toUTCString() : name,
    label: label,
    error: error,
    helperText: helperText,
    placeholder: placeholder,
    value: inputValue === undefined && value ? value : inputValue,
    disabled: disabled,
    required: required,
    small: small,
    onChange: e => onDropdownChange(e),
    onKeyDown: onKeyDown,
    secondaryLabel: secondaryLabel,
    secondaryLabelTheme: secondaryLabelTheme
  }), showSuggestions && suggestionsList.length > 0 && _react.default.createElement("ul", {
    id: 'dropdown-list',
    className: (0, _bind.default)(styles('dropdown-list', displayDirection))
  }, suggestionsList.map((item, i) => {
    const name = typeof item === 'string' ? item : item === null || item === void 0 ? void 0 : item.name;
    const value = typeof item === 'string' ? item : item === null || item === void 0 ? void 0 : item.value;
    return _react.default.createElement("li", {
      "data-testid": dataTestId && `${dataTestId}-${value}`,
      className: (0, _bind.default)(styles(`item-${activeSelection === i && 'active'}`)),
      key: `${i}-${name}`,
      ref: element => optionRefs.current[i] = element,
      onClick: () => selectionClick(i)
    }, _react.default.createElement(_.Text, {
      tag: 'span'
    }, name));
  }))));
});
var _default = Dropdown;
exports.default = _default;